module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value !== "") ? _c('div', {
    staticClass: "edit-comment",
    class: _vm.by ? "left-" + _vm.by.color : ""
  }, [_c('input', {
    attrs: {
      "disabled": !_vm.can_edit
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.update($event.target.value)
      }
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c0058be!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditComment.vue
// module id = 53
// module chunks = 0